<div class="box is-fullheight">
    @if (plan?.data?.plan_flag) {
        <header class="box-header is-justified-center">
            <p class="text">
                {{ plan.data.plan_flag }}
            </p>
        </header>
    }
    <div class="box-content">
        <checkout-card-offer
            [plan]="plan"
            [quoteIndex]="quoteIndex"
            (addProductEvent)="addProductEvent($event)"
            (removeProductEvent)="removeProductEvent($event)"
            (setLockedEvent)="setLocked(plan, $event)"
            [isLoading]="isLoading"
            [cartForm]="cartForm"
            [atLeastOneOfferHasPromoHome]="atLeastOneOfferHasPromoHome"
        />
    </div>
</div>
